module.exports = __webpack_public_path__ + "img/empty.6ef1f662.svg";